import React from "react";
import { withRouter } from "react-router";
import { Redirect, Link } from "react-router-dom";

import MPage from "../templates/mpage";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faEnvelope,
  faPhone,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";

import useObtenerMunicipio from "../../utils/useObtenerMunicipio";

const Contacto = (props) => {
  const [municipio, error] = useObtenerMunicipio(props.match.params.munUrl);

  if (error === true) return <Redirect to="/" />;
  if (municipio === undefined) return null;

  const { nombre, nombreUrl, email, tel, web } = municipio;
  return (
    <MPage municipio={municipio}>
      <h2 className="centrado font-weight-light mt-4 mb-2">Contactanos</h2>
      <div className="centrado">
        <div className="card m-3">
          <div className="card-header font-weight-bold">{nombre}</div>
          <div className="card-body">
            <p>
              <FontAwesomeIcon
                icon={faEnvelope}
                color="#0a4797"
                className="fa-2x mx-3"
              />
              {email}
            </p>
            <p>
              <FontAwesomeIcon
                icon={faPhone}
                color="#0a4797"
                className="fa-2x mx-3"
              />
              {tel}
            </p>
            <p>
              <FontAwesomeIcon
                icon={faGlobe}
                color="#0a4797"
                className="fa-2x mx-3"
              />
              <a className="ppr-a" href={`//${web}`}>
                {web}
              </a>
            </p>
          </div>
        </div>

        <div className="card m-3">
          <div className="card-header font-weight-bold">
            Programa Raiz de Apoyo a la Gestión Local SEU UNC
          </div>
          <div className="card-body">
            <p>
              <FontAwesomeIcon
                icon={faEnvelope}
                color="#0a4797"
                className="fa-2x mx-3"
              />
              gestionlocal@unc.edu.ar
            </p>
          </div>
        </div>

        <center className="mb-3">
          <Link
            to={"/municipio/" + nombreUrl}
            className="btn ppr-btn-verde font-weight-bold m-2"
          >
            Volver
          </Link>
        </center>
      </div>
    </MPage>
  );
};

export default withRouter(Contacto);
